import React from 'react';
import './style.scss';
import CoverReportDetails from './components/CoverReportDetails';
import { useFileQuery } from 'queries/filemanager';
import PageWrapper from '../components/PageWrapper/PageWrapper';

const Cover: React.FC<{
  asset: { name: string; id: string };
  date: string;
  category: string;
  assetDescription?: string;
}> = ({ asset, date, category, assetDescription = '' }) => {
  const { data } = useFileQuery({
    keyName: asset.id,
    keyType: 'asset_health_report_cover',
    fileName: asset.name + '.jpg',
  });

  const img = data && URL.createObjectURL(data);

  return (
    <PageWrapper
      className="cover"
      dataTestId="cover-container"
      style={{ backgroundImage: `url(${img ?? '/images/placeholder.png'})` }}
      assetName={asset.name}
      date={date}
      category={category}
      assetDescription={assetDescription}
    >
      <CoverReportDetails
        asset={asset}
        date={date}
        category={category}
        assetDescription={assetDescription}
      />
    </PageWrapper>
  );
};

export default Cover;
